export const EARLY_ACCESS = 'EARLY_ACCESS'
export const HAS_REQUEST_PROMOCODE = 'HAS_REQUEST_PROMOCODE'
export const LUXOTTICA = 'LUXOTTICA'
export const NONE = 'NONE'
export const UPPERCASE_NONE = NONE.toUpperCase()
export const USER_CLUSTER = 'user_cluster'
export const DCPARAM = 'dcparam'
export const UPPERCASE_USER_CLUSTER = USER_CLUSTER.toUpperCase()
export const EARLY_ACCESS_COOKIE = 'early_access'
